import { styled, withStyles } from "@mui/styles";
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Styles } from "src/styles/material-styles";
import * as articleActions from 'src/redux/actions/articles';
import PropTypes from 'prop-types';
import { AbilityContext } from "src/config/ability-context";
import Api from "src/services/api";
import { Box, Button, Chip, CircularProgress, Container, darken, Divider, Grid, IconButton, ImageList, InputAdornment, TextField, Typography } from "@mui/material";
import Header from "src/components/header-external";
import { PapiroConsole } from "src/utils/papiroConsole";
import { AttachFile, Search } from "@mui/icons-material";
import Footer from "src/components/footer-external";
import * as FileService from 'src/services/attachment.service';
import Modal from "src/components/modal-external/modal-principal";
import MyMaterialTable from 'src/components/table'
import { Overlay } from "src/styles/global";
import CustomizedSnackbars from "src/components/material-snackbars";
import LogoMarca from 'src/images/new-logo2-cmtech.png'
import { activateSpoilers, injectSpoilerStyles } from 'src/components/ReactQuillConfig'
import CalledServicesSettingsExternalFormList from "../client-portal-external/components/called-services-settings-external-form-list";
import CommonSearchExternal from "src/components/client-portal/common-search-external";
import CommonBackButtonExternal from "src/components/client-portal/common-back-button-external";
import ArticleMainContentSkeleton from "src/components/article-external-components/article-main-content-skeleton";

const StyledTextField = styled(TextField)({
    backgroundColor: "#fff",
    borderRadius: "14px",
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        }
    }
})

class KnowledgeBaseExternal extends Component {
    constructor(props) {
        super(props)

        this.initialState = {
            id: 0,
            title: '',
            description: '',
            knowledgeBaseAttachments: [],
        }

        this.state = {
            knowledgeBase: this.initialState,
            clientportal: {},
            hirerid: 0,
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            createCalledDialogOpen: false,
            calledServiceSettingsList: [],
            searchvalue: '',
            searchResults: [],
            searchMode: false,
            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            logoimagesrc: '',
        }

        this.handleChange = this.handleChange.bind(this)
        this.openCreateCalledDialog = this.openCreateCalledDialog.bind(this)
        this.closeCreateCalledDialog = this.closeCreateCalledDialog.bind(this)
        this.getFile = this.getFile.bind(this)
        this.downloadFile = this.downloadFile.bind(this)
        this.closeNotification = this.closeNotification.bind(this)
        this.searchArticle = this.searchArticle.bind(this)
        this.handleBack = this.handleBack.bind(this)
    }

    async componentWillReceiveProps() {
        await this.componentDidMount()
    }

    async componentDidMount() {
        document.title = this.state.appName;

        injectSpoilerStyles()
        this.setState({ loading: true })

        await this.getHirerId()
        await this.getClientPortal()
        await this.getKnowledgeBase()

        this.setState({ loading: false })

        setTimeout(() => activateSpoilers(), 100)
    }

    getHirerId = async () => {
        const intl = this.props.intl

        await Api.get(`/configs/cancreateclientusersexternal`)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0)
                            this.setState({ hirerid: result.data.data.hirerid })
                        else {
                            var l = this.props.match.params.lang;
                            document.location.href = `/${l}/unavailable`
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err)
            })
    }

    async getKnowledgeBase() {
        var { id } = this.props.match.params
        const { intl } = this.props

        await Api.get(`knowledgebases/details/external/${id}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({ knowledgeBase: result.data.data })
                } else {
                    this.setState({
                        loading: false,
                        openNotification: true,
                        notificationVariant: 'error',
                        notificationMessage: result.data && result.data.errors ? result.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    openNotification: true,
                    notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
            })
    }

    async getClientPortal() {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${this.state.hirerid}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({ clientportal: result.data.data })
                    if (result.data.data.logoimage) {
                        this.getFile(result.data.data.logoimage)
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            this.getFile(image)
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    getFile = async (image) => {
        let xhttpImage = new XMLHttpRequest()
        xhttpImage.open("GET", `${image.anonymoustoken}`, false)
        xhttpImage.setRequestHeader('Access-Control-Allow-Origin', '*')
        try {
            xhttpImage.send()
            let ImageData = JSON.parse(xhttpImage.responseText)
            if (ImageData && ImageData.data && ImageData.data.length > 0) {
                this.setState({ logoimagesrc: ImageData.data })
            }
        }
        catch (e) {
            PapiroConsole.log("e")
            PapiroConsole.log(e)
        }
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({ createCalledDialogOpen: true, calledServiceSettingsList: calledServiceSettingsList })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    closeNotification = () => {
        this.setState({ openNotification: false })
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        this.setState({ [name]: value })
    }

    downloadFile = async (file) => {
        const intl = this.props.intl
        let url = await FileService.getFileDownloadLink(file.attachment?.id)
        if (url && url.data && url.data.data && url.data.success) {
            window.open(`${url.data.data}`, "_blank")
        } else {
            this.setState({
                openNotification: true,
                notificationVariant: "error",
                notificationMessage: intl.formatMessage({ id: "file.not.found" }),
            })
        }
    }

    searchArticle = async () => {
        const { searchvalue, hirerid } = this.state
        const { intl } = this.props
        if (!searchvalue.trim()) return

        const encoded = encodeURIComponent(searchvalue)
        this.setState({ loading: true })

        try {
            const result = await Api.get(`knowledgebases/getAllBySearch/${encoded}/hirerid/${hirerid}`)
            if (result.data && result.data.success) {
                const items = (result.data.data ?? []).map(kb => ({
                    id: kb.id,
                    title: kb.title,
                    description: kb.description,
                }))
                this.setState({ searchResults: items, searchMode: true, loading: false })
            } else {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: result.data?.errors?.[0] ?? intl.formatMessage({ id: "process.error" })
                })
            }
        } catch (err) {
            this.setState({
                loading: false, openNotification: true, notificationVariant: 'error',
                notificationMessage: err.response?.data?.errors?.[0] ?? intl.formatMessage({ id: "process.error" })
            })
        }
    }

    handleSearchResultClick = (id) => {
        const { history, match } = this.props
        this.setState({ searchMode: false, searchvalue: '' })
        history.push(`/${match.params.lang}/knowledgebases-external/${id}`)
    }

    handleBack = () => {
        const { history, match } = this.props;
        history.push(`/${match.params.lang}/knowledgebases-external`);
    }

    render() {
        const { classes, intl } = this.props
        const { knowledgeBase, clientportal, logoimagesrc, loading, searchMode, searchResults } = this.state

        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        const attachments = knowledgeBase.knowledgebaseattachments || []

        return (
            <div className={classes.root}>
                <main className={classes.contentExternal}>
                    <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, padding: 0 }}>
                        <Grid container width="100%" direction="column" justifyContent="space-between" minHeight="100vh">
                            <Grid item container spacing={4}>
                                <Header
                                    intl={this.props.intl}
                                    clientportal={clientportal}
                                    calledservicesettings={clientportal.calledservicesettingsclientportals}
                                    language={this.props.match.params.lang}
                                    openCreateCalledDialog={this.openCreateCalledDialog}
                                    logoimagesrc={logoimagesrc}
                                    loading={loading}
                                />

                                <CommonSearchExternal
                                    state={this.state}
                                    clientportal={clientportal}
                                    loading={loading}
                                    nameTextField={"searchvalue"}
                                    handleChange={this.handleChange}
                                    searchArticle={this.searchArticle}
                                    simple
                                />

                                <Grid item sm={12} container marginX="20vw" maxWidth={'60vw'} >
                                    <CommonBackButtonExternal
                                        clientportal={clientportal}
                                        loading={loading}
                                        handleBack={this.handleBack}
                                    />
                                </Grid>

                                <ArticleMainContentSkeleton
                                    showSections={false}
                                    showBreadcrumbs={false}
                                    sectionsCount={1}
                                    articlesPerSection={1}
                                    contentParagraphs={2}
                                    animation="wave"
                                    loading={loading}
                                    mainContainerProps={{
                                        ml: "21.5vw",
                                        mr: "20vw",
                                        mt: 3,
                                        mb: 6,
                                        maxWidth: '60vw'
                                    }}
                                />

                                {!loading && (
                                    <>
                                        {searchMode ? (
                                            <Grid container marginX="20vw" paddingTop={3} maxWidth={'60vw'}>
                                                <Grid item sm={12}>
                                                    {searchResults.length === 0 ? (
                                                        <Typography variant="body1" sx={{ color: '#666' }}>
                                                            Nenhum resultado encontrado.
                                                        </Typography>
                                                    ) : (
                                                        searchResults.map((item) => (
                                                            <Box
                                                                key={item.id}
                                                                onClick={() => this.handleSearchResultClick(item.id)}
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    padding: '12px 8px',
                                                                    borderBottom: '1px solid #e0e0e0',
                                                                    '&:hover': { backgroundColor: '#f5f5f5' },
                                                                }}
                                                            >
                                                                <Typography variant="h5" sx={{ color: clientportal.defaultcolor || 'inherit' }}>
                                                                    {item.title}
                                                                </Typography>
                                                                {item.description && (
                                                                    <Box
                                                                        sx={{
                                                                            display: '-webkit-box',
                                                                            WebkitLineClamp: 3,
                                                                            WebkitBoxOrient: 'vertical',
                                                                            overflow: 'hidden',
                                                                            color: '#666',
                                                                            fontSize: '0.875rem',
                                                                            marginTop: '4px',
                                                                            lineHeight: '1.5',
                                                                        }}
                                                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                                                    />
                                                                )}
                                                            </Box>
                                                        ))
                                                    )}
                                                </Grid>
                                            </Grid>
                                        ) : (
                                            <Grid container marginX="20vw" paddingTop={3} spacing={6} maxWidth={'60vw'} justifyContent={"center"}>
                                                <Grid item container sm={12} spacing={2}>
                                                    <Grid item sm={12}>
                                                        <Typography variant="h2">{knowledgeBase.title}</Typography>
                                                        <Divider sx={{ marginTop: '12px' }} />
                                                    </Grid>

                                                    <Grid item sm={12}>
                                                        <div dangerouslySetInnerHTML={{ __html: knowledgeBase.description }} />
                                                    </Grid>

                                                    {attachments.length > 0 && (
                                                        <Grid item xs={12}>
                                                            <div className={classes.attachmentsBox}>
                                                                <label><FormattedMessage id="attachments" /></label>
                                                                <ImageList cellHeight={100} cols={1}>
                                                                    <ul>
                                                                        {attachments.map((file) => (
                                                                            <li
                                                                                key={file.id}
                                                                                style={{ display: "flex", alignItems: "center" }}
                                                                            >
                                                                                <AttachFile />
                                                                                <Button onClick={() => this.downloadFile(file)}>
                                                                                    {file.attachment?.description || file.attachment?.filename || 'Arquivo'}
                                                                                </Button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </ImageList>
                                                            </div>
                                                        </Grid>
                                                    )}

                                                    {knowledgeBase.knowledgebaseknowledgebasekeywords?.length > 0 && (
                                                        <Grid item xs={12}>
                                                            <Box sx={{ mb: 2 }}>
                                                                <Typography
                                                                    variant="caption"
                                                                    sx={{
                                                                        color: "#6b7280",
                                                                        fontWeight: 600,
                                                                        textTransform: "uppercase",
                                                                        letterSpacing: "0.05em",
                                                                        mb: 1,
                                                                        display: "block",
                                                                    }}
                                                                >
                                                                    {intl.formatMessage({ id: "keywords" })}
                                                                </Typography>
                                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                                                    {knowledgeBase.knowledgebaseknowledgebasekeywords.map((item, index) => (
                                                                        <Chip
                                                                            key={index}
                                                                            label={item.knowledgebasekeyword.word}
                                                                            color="primary"
                                                                            variant="outlined"
                                                                        />
                                                                    ))}
                                                                </Box>
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        )}
                                    </>
                                )}
                            </Grid>

                            <Footer
                                intl={intl}
                                clientportal={clientportal}
                                loading={loading}
                                setLoading={loading => this.setState({ loading: loading })}
                            />
                        </Grid>

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />

                        <Modal
                            intl={intl}
                            title={<strong style={{ color: this.state.clientportal.defaulttextcolor }}>{this.state.clientportal.createcalledpagetitle || intl.formatMessage({ id: "choose.form" })}</strong>}
                            open={this.state.createCalledDialogOpen}
                            onClose={this.closeCreateCalledDialog}
                            contentPadding={false}
                            maxWidth="md"
                            children={
                                <CalledServicesSettingsExternalFormList
                                    calledServiceSettingsList={this.state.calledServiceSettingsList}
                                    clientportal={clientportal}
                                />
                            }
                        />
                    </Container>
                </main>
            </div>
        )
    }
}

KnowledgeBaseExternal.propTypes = (state) => ({
    classes: PropTypes.object.isRequired,
})

const mapStateToProps = (state) => ({
    classes: PropTypes.object.isRequired,
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(articleActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(KnowledgeBaseExternal)));
KnowledgeBaseExternal.contextType = AbilityContext;
